import React, { useEffect } from "react";
import haythemPhoto from "./assets/vitrine/team/Haythem.jpg";
import nizarPhoto from "./assets/vitrine/team/Nizar.jpg";
import akremPhoto from "./assets/vitrine/team/Akram.png";
import "./TeamPage.css";

const TEAM = [
  {
    name: "Haythem JAMAI",
    linkedin: "https://www.linkedin.com/in/haythem-j-786435173/",
    role: "Co-Founder & Chief Executive Officer (CEO)",
    photo: haythemPhoto,
    roleSummary: "Corporate Strategy, Vision & Capital",
    expertise: "Experienced entrepreneur who successfully founded and managed a profitable independent business, combined with managerial leadership in payment systems and transaction infrastructure within corporate banking. Expertise in transactional workflows, cash-flow management, and operational execution.",
    scope: "Visionary behind the Collaborative Living Media model. Orchestrating Weavevo's strategic roadmap, capital allocation, and corporate development. Dedicated to turning decentralized, perpetual video creation into an enterprise and consumer benchmark.",
    focus: "Company vision, fundraising & investor relations, corporate governance, and macro go-to-market execution.",
  },
  {
    name: "Nizar Ben Youssef",
    linkedin: "https://www.linkedin.com/in/nizarbenyoussef/",
    role: "Co-Founder & Chief Business Officer (CBO)",
    photo: nizarPhoto,
    roleSummary: "Partnerships, Commercial Expansion & Ecosystem Growth",
    expertise: "Experienced entrepreneur with a proven background in founding and operating a company in the telecommunications sector. Deep expertise in B2B commercial negotiations, large-scale network rollouts, strategic alliance structuring, and multi-stakeholder operations.",
    scope: "Driving commercial rollout, institutional relationships, and monetization channels. Leads strategic alliances with OTAs, tourism boards, municipal organizations, and retail networks to scale living video adoption across territories.",
    focus: "B2B partnerships, OTA syndication agreements, Weaver Network commercial incentives, and revenue pipeline.",
  },
  {
    name: "Akrem ANAYA",
    linkedin: "https://www.linkedin.com/in/akremanaya/",
    role: "Cloud, AI & Mobile Architect",
    photo: akremPhoto,
    roleSummary: "Cloud Architecture, Dual AI & Mobile Engineering",
    expertise: "Distributed systems engineer and cloud architect with deep background in real-time media streaming, computer vision, and native mobile runtime optimization across high-throughput environments.",
    scope: "Systems architect leading Weavevo’s Google Cloud infrastructure, Dual AI pipelines, and native mobile engineering. Lead architect of Living Weave, orchestrating real-time collaborative video stitching at scale.",
    focus: "Google Cloud (GCP) distributed infrastructure, Dual AI models, native mobile engineering, and high-concurrency video processing.",
  },
];

function TeamCard({ member }) {
  return (
    <article className="team-card">
      <img className="team-photo" src={member.photo} alt={member.name} />
      <h2>{member.name}</h2>
      <h3>{member.role}</h3>
      <div className="team-detail">
        <strong>Role Summary :</strong>
        <p>{member.roleSummary}</p>
      </div>
      <div className="team-detail">
        <strong>Expertise & Track Record :</strong>
        <p>{member.expertise}</p>
      </div>
      <div className="team-detail">
        <strong>Scope at Weavevo :</strong>
        <p>{member.scope}</p>
      </div>
      <div className="team-detail">
        <strong>Key Focus :</strong>
        <p>{member.focus}</p>
      </div>
      <div className="team-detail team-links">
        <strong>Links :</strong>
        <p>
          <a href={member.linkedin} target="_blank" rel="noopener noreferrer">
            LinkedIn
          </a>
        </p>
      </div>
    </article>
  );
}

export default function TeamPage() {
  useEffect(() => {
    document.title = "Team | Weavevo";
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="team-page">
      <section className="team-hero">
        <h1>Building the Future of Collaborative Living Media</h1>
        <p>A multidisciplinary team of engineers, storytellers, and product builders designing perpetual video architecture.</p>
      </section>

      <section className="team-section">
        <h2 className="team-sectionTitle">Founding Team</h2>
        <div className="team-grid">
          {TEAM.map((member) => <TeamCard key={member.name} member={member} />)}
        </div>
      </section>
    </main>
  );
}
